import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Avatar } from '@delmonicos/shared-design-system-react/src/components/avatar/avatar';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { GatewayMinimalUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/shared/models/outputs/gateway-minimal-user.model';
import { useTranslation } from 'react-i18next';

interface AssigneeCardComponentProps {
  assignee?: GatewayMinimalUserModel;
}

export const AssigneeCardComponent = ({
  assignee,
}: AssigneeCardComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        icon="user-01"
        variant={AccentVariantEnum.Accent1}
        text={t('$.ticket-details.assignee-card.title')}
      />
      {assignee ? (
        <Avatar firstName={assignee.firstName} lastName={assignee.lastName} />
      ) : (
        <Text color={TextColor.Secondary}>
          {t('$.ticket-list.no-assignee')}
        </Text>
      )}
    </Card>
  );
};
